import { useLoadingStore } from '../../store';
import './LoadingOverlay.css';

function LoadingOverlay() {
  const { isLoading, loadingMessage } = useLoadingStore();

  if (!isLoading) return null;

  return (
    <div className="overlay-loadingoverlay">
      <div className="content-loadingoverlay">
        <div className="spinner-loadingoverlay"></div>
        {loadingMessage && (
          <p className="message-loadingoverlay">{loadingMessage}</p>
        )}
      </div>
    </div>
  );
}

export default LoadingOverlay;
